import { fadeIn, fadeOut } from '../../utilities/helpers';
import { disableButton, enableButton } from './helper';
import { getPrice } from './price';

declare var mp: any;
declare var _satellite: any;

export class toCart {

  init() {
    const baskets = document.querySelectorAll('.add-to-basket, .toggle-article-to-basket');

    baskets.forEach((basket: HTMLButtonElement) => {
      basket.addEventListener('click', () => {
        if (basket.classList.contains('add-to-basket')) {
          addToBasket(basket, false, false);
        }
        if (basket.classList.contains('toggle-article-to-basket')) {
          addToBasket(basket, false, false, true, true);
        }
      });
    });
  }

  initVariants() {
    const baskets = document.querySelectorAll('.toggle-variant-to-basket');

    baskets.forEach((basket: HTMLButtonElement) => {
      basket.addEventListener('click', () => {
        addToBasket(basket, true, false);
      });
    });
  }
  initAccessory() {
    const baskets = document.querySelectorAll('.pda-accessory-table .toggle-accessory-to-basket');

    baskets.forEach((basket: HTMLButtonElement) => {
      basket.addEventListener('click', () => {
        addToBasket(basket, false, true);
      });
    });
  }

  initOverlayAccessory() {
    if(document.querySelector('.pda-overlay-accessory-table .toggle-accessory-to-basket')) {
      const baskets = document.querySelectorAll('.pda-overlay-accessory-table .toggle-accessory-to-basket');

      baskets.forEach((basket: HTMLButtonElement) => {
        basket.addEventListener('click', () => {
          addToBasket(basket, false, true, false, false, 'PDS_CartAdd_Layer');
        });
      });
    }
  }

  initCartAccessory() {
    if(document.querySelector('.cart-overlay-accessory-table .toggle-accessory-to-basket')) {
      const baskets = document.querySelectorAll('.cart-overlay-accessory-table .toggle-accessory-to-basket');

      baskets.forEach((basket: HTMLButtonElement) => {
        basket.addEventListener('click', () => {
          addToBasket(basket, false, true, false, false, 'PDS_CartAdd_CartAccessory');
        });
      });
    }
  }

  addMultipleToBasket(button: HTMLButtonElement, trackingParam?: string) {
    disableButton(button);

    const section = button.closest('.reco-orderedTogether.v3');

    const checkboxes = [].slice.call(section.querySelectorAll('.item-orderedTogether input[name^="article-ordered-together-"]:checked'));
    let checkedBoxes:Array<number> = [];

    if(typeof checkboxes !== 'undefined') {
      checkboxes.forEach((checkbox: HTMLInputElement) => {
        checkedBoxes.push(parseInt(checkbox.dataset.articleId));
      });
    }

    document.querySelectorAll('.js-modal-addedtocart-header')[0].innerHTML = mp.modal_addedtocart_cart_header_multiple;
    document.querySelectorAll('.js-modal-addedtocart-shopping')[0].innerHTML = mp.modal_addedtocart_cart_shopping;
    document.querySelectorAll('.js-modal-addedtocart-tocart span')[0].innerHTML = mp.modal_addedtocart_cart_tocart;

    let dataPost: string = '';

    checkedBoxes.forEach((id, index) => {
      const articleIdString: string = index == 0 ? 'articleId=' : '&articleId=';
      dataPost += articleIdString + id;
    })
    checkedBoxes.forEach((id, index) => {
      dataPost += '&quantity=1';
    })

    window.fetch('/order/cart', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: dataPost,
    })
        .then(response => response)
        .then(data => {
          console.log(data);

          const referenceRow = document.querySelector('#modal-addedtobasket .ogRow') as HTMLElement;
          if (referenceRow) referenceRow.style.display = 'none';
          const cloneRows = Array.from(document.querySelectorAll('#modal-addedtobasket .cloneRow'));
          cloneRows.forEach(row => row.remove());

          const selectedArticles = Array.from(document.querySelectorAll('.reco-orderedTogether.v3 .item-orderedTogether input[name^="article-ordered-together-"]:checked'));
          selectedArticles.forEach((article, index) => {
            const aQuantity = 1;
            const aTitle = article.parentElement.querySelector('.product-title').innerHTML;
            const aPrice = article.parentElement.querySelector('.price-offer').innerHTML;
            const aPriceUnformatted = article.parentElement.querySelector('.price-offer span').getAttribute('data-price');
            const aId = article.getAttribute('data-article-id');
            const aImageSrc = (article.parentElement.querySelector('.product-slide-image img') as HTMLImageElement).src;
            const aImage = '<img src="'+ aImageSrc + '" />';
            const aPId = article.parentElement.getAttribute('data-product-id');

            const newRow = referenceRow.cloneNode(true) as HTMLElement;

            newRow.classList.remove('ogRow');
            newRow.classList.add('cloneRow');
            newRow.style.display = 'block';

            newRow.querySelector('.modal-product-title').innerHTML = aTitle;
            newRow.querySelector('.modal-product-id').innerHTML = aId;
            newRow.querySelector('.modal-product-price').innerHTML = aPrice;
            newRow.querySelector('.modal-product-image').innerHTML = aImage;
            newRow.setAttribute('data-price', aPriceUnformatted);
            newRow.setAttribute('data-product-id', aPId);


            if(index == 0) {
              (<HTMLElement>newRow.querySelector('.modal-product-sum-all-prices')).innerHTML = '<span class="prc-saving">' + section.querySelector('.reco-orderedTogether-total').parentElement.innerHTML + '</span>';
              (<HTMLElement>newRow.querySelector('.modal-product-sum-all-prices')).style.marginTop = '2rem';
            } else {
              (<HTMLElement>newRow.querySelector('.modal-product-sum-all-prices')).style.display = 'none';
            }

            referenceRow.parentNode.insertBefore(newRow, referenceRow.nextSibling);
          });

          if (typeof _satellite !== 'undefined' && _satellite) {
            if(trackingParam) {
              _satellite.track(trackingParam);
            }
          }

          if(!document.querySelector('#modal-addedtobasket.mdl-background')) {
            fadeIn(document.querySelector('.modal-background'));
          }
          fadeIn(document.querySelector('#modal-addedtobasket'));

          const flyoutStyle = '&layout=v2';

          window.fetch('/order/cart/flyout?type=cart' + flyoutStyle)
              .then(response => response.text())
              .then((data: any) => {
                document.querySelectorAll('.flyout-cart')[0].innerHTML = data;

                const flyoutItemCount = (document.querySelectorAll('.flyout-cart .flyout-cart-item-count')[0] as HTMLElement).innerText;
                document.querySelectorAll('.js-head-cart-itemcount').forEach((item: HTMLElement) => item.innerHTML = flyoutItemCount);
              });

          enableButton(button);

          const recoLoadedEvent = new CustomEvent('recoLoaded', { detail: '.basket-slider;3' });
          setTimeout(() => window.dispatchEvent(recoLoadedEvent), 100);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
  }
}

export function addToBasket(button: HTMLButtonElement, is_variant: boolean, is_accessory: boolean, popup = true, is_toggle?: boolean, trackingParam?: string) {
  disableButton(button);

  let articleId: string | null;
  let articleTitle: string | null;
  let articlePrice: string | null;
  let mobileImageLink: string | null;
  let tabletImageLink: string | null;
  let quantity: string | null;
  let priceListName = '';
  if(!is_accessory && !is_variant) {
    articleTitle = document.getElementById('article-title')?.innerText;
    articlePrice = document.querySelector<HTMLSpanElement>('.price-detail-offer')?.innerText;
    mobileImageLink = document.querySelector<HTMLSourceElement>('#pda-gallery-hero .splide__slide.is-active picture source[media="(max-width: 768px)"]')?.srcset;
    tabletImageLink = document.querySelector<HTMLSourceElement>('#pda-gallery-hero .splide__slide.is-active picture source[media="(min-width: 768px)"]')?.srcset;
    if (!mobileImageLink) {
      mobileImageLink = document.querySelector<HTMLSourceElement>('#pda-gallery-hero .splide__slide picture source[media="(max-width: 768px)"]')?.srcset;
    }

    if (!tabletImageLink) {
      tabletImageLink = document.querySelector<HTMLSourceElement>('#pda-gallery-hero .splide__slide picture source[media="(min-width: 768px)"]')?.srcset;
    }

    articleId = document.querySelector('.pda')?.getAttribute('data-article-id');
    priceListName = document.querySelectorAll('.pda')[0].getAttribute('data-article-pricelist');
  }
  let eventId = '';

  if (is_variant) {
    const variantRow = button.closest('.product-list-row');
    quantity = variantRow.querySelector<HTMLInputElement>('.basket-quantity')?.value;
    articleTitle = variantRow.querySelector<HTMLAnchorElement>('.product-list-title a')?.innerText;
    articlePrice = variantRow.querySelector('.product-variant-price-wrapper .variant-price').innerHTML;
    articleId = button.getAttribute('data-article-id');
    mobileImageLink = variantRow.querySelector<HTMLImageElement>('.product-list-image img')?.src;
    tabletImageLink = mobileImageLink
  } else if (is_accessory) {
    const accessoryRow = button.closest('.product-accessory-row');
    quantity = accessoryRow.querySelector<HTMLInputElement>('.basket-quantity')?.value;
    articleTitle = accessoryRow.querySelector<HTMLAnchorElement>('.product-accessory-title a')?.innerText;
    articlePrice = accessoryRow.querySelector('.product-accessory-price-wrapper .price-offer').innerHTML;
    articleId = button.getAttribute('data-article-id');
    mobileImageLink = accessoryRow.querySelector<HTMLImageElement>('.product-accessory-image img')?.src;
    tabletImageLink = mobileImageLink
  } else if (is_toggle) {
    quantity = '1';
  } else {
    quantity = document.querySelector<HTMLInputElement>('#basket-quantity')?.value;
  }

  if (document.querySelector('#event-id') && typeof (document.querySelectorAll('#event-id')[0] as HTMLElement).dataset.id != 'undefined') {
    eventId = (document.querySelectorAll('#event-id')[0] as HTMLElement).dataset.id;
  }

  let articleIdWithPriceListName = articleId;
  if (typeof priceListName !== 'undefined' && priceListName !== '') {
      articleIdWithPriceListName = articleId + '-' + priceListName;
  }
  const dataPost = 'quantity=' + quantity + '&articleId=' + articleIdWithPriceListName + '&ti=' + eventId + '&type=cart';

  window.fetch('/order/cart/item', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: dataPost,
  })
  .then(response => response)
  .then(data => {
    if (!popup) {
      const qtyTracker = button.parentElement.querySelector('.variant-to-cart-success .addedtocart-qty');
      if(qtyTracker) {
        if(qtyTracker.innerHTML == '') {
          qtyTracker.innerHTML = quantity;
        } else {
          qtyTracker.innerHTML = "" + (parseInt(qtyTracker.innerHTML) + parseInt(quantity));
        }
      }
      (button.parentElement.querySelector('.variant-to-cart-success') as HTMLElement).style.display = 'block';
    }

    if (typeof _satellite !== 'undefined' && _satellite) {
      if(trackingParam == 'PDS_CartAdd_Layer') {
        _satellite.track('PDS_CartAdd_Layer');
      } else if (trackingParam == 'PDS_CartAdd_CartAccessory') {
        _satellite.track('PDS_CartAdd_CartAccessory');
        if(document.querySelector('#modal-accessory .cart-accessory-close')) {
          document.querySelector('#modal-accessory .cart-accessory-close').classList.add('reload');
        }
      } else {
        _satellite.track('PDS_CartAdd');
      }
    }

    if (popup) {
      const qQuantity = parseInt(quantity)

      if (Number.isNaN(qQuantity)) {
        throw new Error("Quantity could not be parsed")
      }

      getPrice(articleId, qQuantity, 'summary').then((sumHtml) => {
        if (!sumHtml) {
          throw new Error("Sum could not be received")
        }

        const div = document.createElement("div")
        div.innerHTML = sumHtml
        const span = div.querySelector("span")

        if (!span) {
          throw new Error("Sum could not be extracted")
        }

        const sum = span.innerText.split(": ")[1]

        if (!sum) {
          throw new Error("Sum could not be extracted")
        }

        let accessories: {
          title: string;
          price: string;
          unit: string;
          rating?: ("full" | "half" | "empty")[];
          link: string;
          imageAlt: string;
          mobileImageLink: string;
          tabletImageLink: string;
          desktopImageLink: string;
        }[] | undefined = undefined
        let reco: typeof accessories = undefined

        if (document.getElementById("product-accessoires-table")) {
          accessories = Array.from(
            document.querySelectorAll(".product-accessory-row")
          ).map((accessory) => {
            const title = accessory.querySelector<HTMLAnchorElement>(
              ".product-accessory-title a"
            )?.innerText;
            const price =
              accessory.querySelector<HTMLSpanElement>(".price-offer")?.innerText;
            const unit =
              accessory.querySelector<HTMLSpanElement>(
                ".price-list-info"
              )?.innerText;
            const rating = Array.from(
              accessory.querySelector(".ratingStar")?.children ?? []
            ).reduce<(typeof accessories)[number]["rating"]>((acc, child) => {
              if (child.classList.contains("uil-star-active")) {
                return acc === undefined ? ["full"] : [...acc, "full"];
              }

              if (child.classList.contains("uil-star-half-alt-active")) {
                return acc === undefined ? ["half"] : [...acc, "half"]
              }

              return acc === undefined ? ["empty"] : [...acc, "empty"];
            }, undefined);
            const link = accessory.querySelector<HTMLAnchorElement>(
              ".product-accessory-title a"
            )?.href;
            const imageAlt = title;
            const mobileImageLink = accessory.querySelector<HTMLImageElement>(
              ".product-accessory-image img"
            )?.src;
            const tabletImageLink = mobileImageLink;
            const desktopImageLink = mobileImageLink;

            if (
              !title ||
              !price ||
              !unit ||
              !link ||
              !imageAlt ||
              !mobileImageLink ||
              !tabletImageLink ||
              !desktopImageLink
            ) {
              throw new Error(
                "Could not initialize add-to-cart-layer accessories"
              );
            }

            return {
              title,
              price,
              unit,
              rating,
              link,
              imageAlt,
              mobileImageLink,
              tabletImageLink,
              desktopImageLink,
            };
          });
        } else if (document.getElementById("reco-crossseller")) {
          reco = Array.from(
            document.getElementById("swiper-recommendation-itembased")?.children ?? []
          ).map((accessory) => {
            const title = accessory.querySelector<HTMLAnchorElement>(
              ".product-title"
            )?.innerText;
            const price =
              accessory.querySelector<HTMLSpanElement>(".price-offer")?.innerText;
            const unit =
              accessory.querySelector<HTMLSpanElement>(
                ".price-list-info"
              )?.innerText;
            const rating = Array.from(
              accessory.querySelector(".ratingStar")?.children ?? []
            ).reduce<(typeof accessories)[number]["rating"]>((acc, child) => {
              if (child.classList.contains("uil-star-active")) {
                return acc === undefined ? ["full"] : [...acc, "full"];
              }

              if (child.classList.contains("uil-star-half-alt-active")) {
                return acc === undefined ? ["half"] : [...acc, "half"]
              }

              return acc === undefined ? ["empty"] : [...acc, "empty"];
            }, undefined);
            const link = accessory.querySelector<HTMLAnchorElement>(
              ".product-slide"
            )?.href;
            const imageAlt = title;
            const mobileImageLink = accessory.querySelector<HTMLImageElement>(
              ".product-slide-image img"
            )?.src;
            const tabletImageLink = mobileImageLink;
            const desktopImageLink = mobileImageLink;

            if (
              !title ||
              !price ||
              !unit ||
              !link ||
              !imageAlt ||
              !mobileImageLink ||
              !tabletImageLink ||
              !desktopImageLink
            ) {
              throw new Error(
                "Could not initialize add-to-cart-layer reco"
              );
            }

            return {
              title,
              price,
              unit,
              rating,
              link,
              imageAlt,
              mobileImageLink,
              tabletImageLink,
              desktopImageLink,
            };
          });
        }

        document.dispatchEvent(
          new CustomEvent("pda.cart.add-to-cart", {
            detail: {
              article: {
                articleNumber: articleId,
                title: articleTitle,
                imageAlt: articleTitle,
                mobileImageLink,
                tabletImageLink,
              },
              accessories,
              reco,
              quantity: qQuantity,
              sum,
            },
          })
        );
      })
    }

    if (is_variant || is_accessory) {
      //fadeIn(button.parentElement.querySelector('.variant-to-cart-success'));
      //setTimeout(() => fadeOut(button.parentElement.querySelector('.variant-to-cart-success')), 2500)
    }

    const flyoutStyle = '&layout=v2';

    window.fetch('/order/cart/flyout?type=cart' + flyoutStyle)
      .then(response => response.text())
      .then((data: any) => {
        document.querySelectorAll('.flyout-cart')[0].innerHTML = data;

        const flyoutItemCount = (document.querySelectorAll('.flyout-cart .flyout-cart-item-count')[0] as HTMLElement).innerText;
        document.querySelectorAll('.js-head-cart-itemcount').forEach((item: HTMLElement) => item.innerHTML = flyoutItemCount);
      });

    enableButton(button);

    const recoLoadedEvent = new CustomEvent('recoLoaded', { detail: '.basket-slider;3' });
    setTimeout(() => window.dispatchEvent(recoLoadedEvent), 100);
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
